import { Feature, FeatureCollection } from "geojson";
import { gql } from "apollo-angular";
import { Injectable, inject } from "@angular/core";
import * as Apollo from "apollo-angular";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  GeoJsonFeature: { input: Feature; output: Feature };
  GeoJsonFeatureCollection: { input: FeatureCollection; output: FeatureCollection };
  Time: { input: Date; output: Date };
  Timestamp: { input: any; output: any };
};

export type FtsCancelAlertInput = {
  id: Scalars["ID"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
};

export type FtsLogDownload = {
  __typename?: "FTSLogDownload";
  registration: Scalars["String"]["output"];
  routeinfo?: Maybe<Scalars["String"]["output"]>;
  summary?: Maybe<Scalars["String"]["output"]>;
};

export type FtsLogDownloadInput = {
  id: Scalars["ID"]["input"];
};

export type FtsStartFlightInput = {
  currentState?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  tod: Scalars["Timestamp"]["input"];
};

export type FtsStopFlightInput = {
  currentState?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  toa: Scalars["Timestamp"]["input"];
};

export type FtsUpdateLocationInput = {
  id: Scalars["ID"]["input"];
  location: Location;
};

export type FlightInfoInput = {
  aircraftDescription?: InputMaybe<Scalars["String"]["input"]>;
  aircraftType?: InputMaybe<Scalars["String"]["input"]>;
  alertsFrom?: InputMaybe<Scalars["Time"]["input"]>;
  alertsUntil?: InputMaybe<Scalars["Time"]["input"]>;
  currentState?: InputMaybe<Scalars["String"]["input"]>;
  departureFrom?: InputMaybe<Scalars["GeoJsonFeature"]["input"]>;
  destination: Scalars["GeoJsonFeature"]["input"];
  deviceID?: InputMaybe<Scalars["String"]["input"]>;
  etd?: InputMaybe<Scalars["Timestamp"]["input"]>;
  flightId?: InputMaybe<Scalars["String"]["input"]>;
  flightNumber?: InputMaybe<Scalars["String"]["input"]>;
  operationalFlightplan: Scalars["String"]["input"];
  registration: Scalars["String"]["input"];
  route?: InputMaybe<Scalars["GeoJsonFeatureCollection"]["input"]>;
  routeString?: InputMaybe<Scalars["String"]["input"]>;
  sarInfo?: InputMaybe<SarInfoInput>;
};

export type Location = {
  gs?: InputMaybe<Scalars["Float"]["input"]>;
  lat: Scalars["Float"]["input"];
  lon: Scalars["Float"]["input"];
  track?: InputMaybe<Scalars["Float"]["input"]>;
};

export type MapLayerGeoJson = {
  __typename?: "MapLayerGeoJson";
  description?: Maybe<Scalars["String"]["output"]>;
  features: Scalars["GeoJsonFeatureCollection"]["output"];
  id: Scalars["ID"]["output"];
  styleUrl?: Maybe<Scalars["String"]["output"]>;
  type: MapLayerType;
};

export type MapLayerTileUrl = {
  __typename?: "MapLayerTileUrl";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  styleUrl?: Maybe<Scalars["String"]["output"]>;
  tileUrl?: Maybe<Scalars["String"]["output"]>;
  type: MapLayerType;
};

export enum MapLayerType {
  Geojson = "GEOJSON",
  VectorXyz = "VECTOR_XYZ",
}

export type MapLayerUpdate = {
  __typename?: "MapLayerUpdate";
  id: Scalars["ID"]["output"];
};

export type Mutation = {
  __typename?: "Mutation";
  ftsCancelAlert: Scalars["ID"]["output"];
  ftsLogDownload: FtsLogDownload;
  ftsStartFlight: Scalars["ID"]["output"];
  ftsStopFlight: Scalars["ID"]["output"];
  ftsUpdateLocation: Scalars["ID"]["output"];
  mapLayerAsGeoJson: MapLayerGeoJson;
  mapLayerAsTileUrl: MapLayerTileUrl;
  requestSafeSkyAuth: SafeSkyAuth;
  saveFlightInfo: Scalars["ID"]["output"];
  updateLocation?: Maybe<Scalars["Boolean"]["output"]>;
};

export type MutationFtsCancelAlertArgs = {
  cancelAlert: FtsCancelAlertInput;
  registration: Scalars["String"]["input"];
};

export type MutationFtsLogDownloadArgs = {
  logDownloadRequest: FtsLogDownloadInput;
  registration: Scalars["String"]["input"];
};

export type MutationFtsStartFlightArgs = {
  registration: Scalars["String"]["input"];
  startFlight: FtsStartFlightInput;
};

export type MutationFtsStopFlightArgs = {
  registration: Scalars["String"]["input"];
  stopFlight: FtsStopFlightInput;
};

export type MutationFtsUpdateLocationArgs = {
  registration: Scalars["String"]["input"];
  updateLocation: FtsUpdateLocationInput;
};

export type MutationMapLayerAsGeoJsonArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationMapLayerAsTileUrlArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationRequestSafeSkyAuthArgs = {
  registration?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationSaveFlightInfoArgs = {
  flightInfo: FlightInfoInput;
  requestID?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateLocationArgs = {
  id: Scalars["ID"]["input"];
  newLocation: Location;
};

export type Query = {
  __typename?: "Query";
  dummy: Scalars["Boolean"]["output"];
};

export type SafeSkyAuth = {
  __typename?: "SafeSkyAuth";
  address: Scalars["String"]["output"];
  addressType: Scalars["String"]["output"];
  addressTypeNumeric: Scalars["Int"]["output"];
  salt: Scalars["String"]["output"];
  valid: Scalars["Boolean"]["output"];
};

export type SarInfoInput = {
  endurance: Scalars["Int"]["input"];
  picName: Scalars["String"]["input"];
  picPhone?: InputMaybe<Scalars["String"]["input"]>;
  pob: Scalars["Int"]["input"];
};

export type Subscription = {
  __typename?: "Subscription";
  mapLayerUpdates: MapLayerUpdate;
};

export type SubscriptionMapLayerUpdatesArgs = {
  id: Scalars["ID"]["input"];
};

export type TrafficInfo = {
  __typename?: "TrafficInfo";
  flights: Scalars["GeoJsonFeatureCollection"]["output"];
  id: Scalars["ID"]["output"];
};

export type MapLayerUpdatesSubscriptionVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type MapLayerUpdatesSubscription = {
  __typename?: "Subscription";
  mapLayerUpdates: { __typename?: "MapLayerUpdate"; id: string };
};

export type UpdateLocationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  newLocation: Location;
}>;

export type UpdateLocationMutation = { __typename?: "Mutation"; updateLocation?: boolean | null };

export type MapLayerAsGeoJsonMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type MapLayerAsGeoJsonMutation = {
  __typename?: "Mutation";
  mapLayerAsGeoJson: { __typename?: "MapLayerGeoJson"; id: string; type: MapLayerType; features: FeatureCollection };
};

export type SaveFlightInfoMutationVariables = Exact<{
  requestID: Scalars["String"]["input"];
  flightInfo: FlightInfoInput;
}>;

export type SaveFlightInfoMutation = { __typename?: "Mutation"; saveFlightInfo: string };

export type FtsStartFlightMutationVariables = Exact<{
  registration: Scalars["String"]["input"];
  startFlight: FtsStartFlightInput;
}>;

export type FtsStartFlightMutation = { __typename?: "Mutation"; ftsStartFlight: string };

export type FtsStopFlightMutationVariables = Exact<{
  registration: Scalars["String"]["input"];
  stopFlight: FtsStopFlightInput;
}>;

export type FtsStopFlightMutation = { __typename?: "Mutation"; ftsStopFlight: string };

export const MapLayerUpdatesDocument = gql`
  subscription mapLayerUpdates($id: ID!) {
    mapLayerUpdates(id: $id) {
      id
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class MapLayerUpdatesGQL extends Apollo.Subscription<
  MapLayerUpdatesSubscription,
  MapLayerUpdatesSubscriptionVariables
> {
  document = MapLayerUpdatesDocument;

  constructor() {
    const apollo = inject(Apollo.Apollo);

    super(apollo);
  }
}
export const UpdateLocationDocument = gql`
  mutation updateLocation($id: ID!, $newLocation: Location!) {
    updateLocation(id: $id, newLocation: $newLocation)
  }
`;

@Injectable({
  providedIn: "root",
})
export class UpdateLocationGQL extends Apollo.Mutation<UpdateLocationMutation, UpdateLocationMutationVariables> {
  document = UpdateLocationDocument;

  constructor() {
    const apollo = inject(Apollo.Apollo);

    super(apollo);
  }
}
export const MapLayerAsGeoJsonDocument = gql`
  mutation mapLayerAsGeoJson($id: ID!) {
    mapLayerAsGeoJson(id: $id) {
      id
      type
      features
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class MapLayerAsGeoJsonGQL extends Apollo.Mutation<
  MapLayerAsGeoJsonMutation,
  MapLayerAsGeoJsonMutationVariables
> {
  document = MapLayerAsGeoJsonDocument;

  constructor() {
    const apollo = inject(Apollo.Apollo);

    super(apollo);
  }
}
export const SaveFlightInfoDocument = gql`
  mutation saveFlightInfo($requestID: String!, $flightInfo: FlightInfoInput!) {
    saveFlightInfo(requestID: $requestID, flightInfo: $flightInfo)
  }
`;

@Injectable({
  providedIn: "root",
})
export class SaveFlightInfoGQL extends Apollo.Mutation<SaveFlightInfoMutation, SaveFlightInfoMutationVariables> {
  document = SaveFlightInfoDocument;

  constructor() {
    const apollo = inject(Apollo.Apollo);

    super(apollo);
  }
}
export const FtsStartFlightDocument = gql`
  mutation ftsStartFlight($registration: String!, $startFlight: FTSStartFlightInput!) {
    ftsStartFlight(registration: $registration, startFlight: $startFlight)
  }
`;

@Injectable({
  providedIn: "root",
})
export class FtsStartFlightGQL extends Apollo.Mutation<FtsStartFlightMutation, FtsStartFlightMutationVariables> {
  document = FtsStartFlightDocument;

  constructor() {
    const apollo = inject(Apollo.Apollo);

    super(apollo);
  }
}
export const FtsStopFlightDocument = gql`
  mutation ftsStopFlight($registration: String!, $stopFlight: FTSStopFlightInput!) {
    ftsStopFlight(registration: $registration, stopFlight: $stopFlight)
  }
`;

@Injectable({
  providedIn: "root",
})
export class FtsStopFlightGQL extends Apollo.Mutation<FtsStopFlightMutation, FtsStopFlightMutationVariables> {
  document = FtsStopFlightDocument;

  constructor() {
    const apollo = inject(Apollo.Apollo);

    super(apollo);
  }
}
